import { Injectable, inject } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';


interface Response {
  status: 'success' | 'error';
  code: number;
  message: string;
  error: string | null;
  payload: Object | null;
}

@Injectable({
  providedIn: 'root'
})
export class CloudFunctionsService {

  private functions: Functions;

  constructor() {
    this.functions = inject(Functions);
  }

  callFunction(functionName: string, data: any): Promise<Response> {
    const callable = httpsCallable(this.functions, functionName);
    return callable(data).then(result => result.data as Response);
  }
}